// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useFile } from '../context/filecontext';

const ProtectedRoute = ({ children }) => {
  const { metadataUrl, setShowNotification } = useFile();
  const location = useLocation();

  // Only show notification if there's no metadata URL and we're not coming from a direct page load
  if (!metadataUrl && !localStorage.getItem('metadataUrl')) {
    if (location.pathname === '/viewer') {
      setShowNotification(true);
    }
    return <Navigate to="/upload" replace />;
  }

  return children;
};

export default ProtectedRoute;